import React from "react";
import ModalContainer from "../ModalContainer/ModalContainer";
import Button from "../Button/Button";

const ConfirmationModal = (props) => {
  const { buttons=[], close, children } = props;

  return (
    <ModalContainer close={close}>
      <div style={{ textAlign: "center" }}>
        {children}
        {buttons.map((item) => (
          <Button key={`modal_${item.name}`} {...item}>
            {item.name}
          </Button>
        ))}
      </div>
    </ModalContainer>
  );
};

export default ConfirmationModal;
